import { defineMessages } from '@jutro/locale';

export default defineMessages({
    allDocuments: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.All Documents',
        'defaultMessage': 'All Documents'
    },
    policyDocuments: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Policy Documents',
        'defaultMessage': 'Policy Documents'
    },
    billingDocuments: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Billing Documents',
        'defaultMessage': 'Billing Documents'
    },
    claimsDocuments: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Claims Documents',
        'defaultMessage': 'Claims Documents'
    },
    documentsYouSent: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Documents You Sent',
        'defaultMessage': 'Documents You Sent'
    },
    idCards: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.ID Cards',
        'defaultMessage': 'ID Cards'
    },
    documentsDate: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Date',
        'defaultMessage': 'Date'
    },
    documentsContent: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Document',
        'defaultMessage': 'Document'
    },
    documentsType: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Type',
        'defaultMessage': 'Type'
    },
    documentsAction: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Actions',
        'defaultMessage': 'Actions'
    },
    downloadingDocument: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Downloading document...',
        'defaultMessage': 'Downloading document...'
    },
    documentDownloadErrorHeader: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Error',
        'defaultMessage': 'Error'
    },
    documentDownloadErrorMessage: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Were sorry. We were unable to download your document, please try again.',
        'defaultMessage': 'We\'re sorry. We were unable to download your document, please try again.'
    },
    prior30Days: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.30 days',
        'defaultMessage': '30 days'
    },
    prior90Days: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.90 days',
        'defaultMessage': '90 days'
    },
    prior6Months:{    
        'id': 'ml.policy.PolicyAccountDocumentsComponent.6 months',
        'defaultMessage': '6 months'
    },
    prior1Year: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.1 year',
        'defaultMessage': '1 year'
    },
    prior3Years: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.3 years',
        'defaultMessage': '3 years'
    },
    prior5Years: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.5 years',
        'defaultMessage': '5 years'
    },
    noDocumentMessage: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.No documents are available for this category for the timeframe selected.',
        'defaultMessage': 'No documents are available for this category for the timeframe selected.'
    },
    generatingDocument: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Generating...',
        'defaultMessage': 'Generating...'
    },
    viewPrintDocument: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.View / Print',
        'defaultMessage': 'View / Print'
    },
    filterText: {
        "id": "ml.policy.PolicyAccountDocumentsComponent.Filter:",
        "defaultMessage": "Filter:"
    },
    newToPortal: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.NEW',
        'defaultMessage': "NEW"
    },
    actionRequired: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.ACTION REQUIRED',
        'defaultMessage': 'ACTION REQUIRED'
    },
    uploadDocument: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Upload Documents',
        'defaultMessage': 'Upload documents'
    },
    unableUploadDocument: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.What if I can\'t upload my documents',
        'defaultMessage': 'What if I can\'t upload my documents'
    },
    unableToUploadDetails: {
        'id': 'ml.policy.PolicyAccountDocumentsComponent.Fax to 1-866-743-4890, Email them to autoandhomerequest@farmersinsurance.com, Mail to: ATTENTION: SERVICES FARMERS INSURANCE PO BOX 6060 SCRANTON, PA 18505-6060.  Please be sure to include your name and policy number with the document.',
        'defaultMessage': 'Fax to 1-866-743-4890, Email them to autoandhomerequest@farmersinsurance.com, Mail to: ATTENTION: SERVICES FARMERS INSURANCE PO BOX 6060 SCRANTON, PA 18505-6060.  Please be sure to include your name and policy number with the document.'
    }
});